import React, { useState, useEffect } from "react";


import "devextreme/data/odata/store";
import { useDispatch, useSelector } from "react-redux";
import CustomStore from "devextreme/data/custom_store";
import Request from "../../../components/api/Request";
import { TreeList, FilterRow, Selection, SearchPanel, Column, RowDragging, Editing, } from 'devextreme-react/tree-list';
import './Domain.scss';
import * as AppActions from '../../../actions/AppActions';
import DomainDetay from "./DomaineDetay";
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { custom } from 'devextreme/ui/dialog';
import FileUploader from 'devextreme-react/file-uploader'; 
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate,hasRole,showDialog } from "../../../utils/Utils";
import DomainCustomTesvikPersonel from "./DomainCustomTesvikPersonel";

const Domain = () => {
    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("tanimlar|domain|listele"),    
            goruntule: hasRole("tanimlar|domain|goruntule"),    
            ekle: hasRole("tanimlar|domain|ekle"),    
            degistir: hasRole("tanimlar|domain|degistir"),    
            sil: hasRole("tanimlar|domain|sil"), 
            domainTesvikDetaySil: hasRole("tanimlar|domain|domainTesvikDetaySil"), 
            moveDomain: hasRole("tanimlar|domain|moveDomain"), 
            dosyaYukle: hasRole("tanimlar|domain|dosyaYukle"), 
            excelSablon: hasRole("tanimlar|domain|excelSablon") , 
            yetkiliKullanicilist: hasRole("tanimlar|domain|yetkiliKullanicilist") ,
            domainCutomTesvikForm: hasRole("tanimlar|domainCutomTesvik|listele") 

        });

    const [store, setStore] = useState(null);
    const [domainData, setDomainData] = useState({ popupState: false, data: [] });
    const inputOpenFileRef = React.createRef();
    const [personelCustomTesvikFormData, setPersonelCustomTesvikFormData] = useState({ popupState: false, data: {} });

    useEffect(() => {
        yenile();
    }, []);

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            load: function () {

                const request = new Request("/domain/getKayitList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const yenile = () => {
        setStore(getStore());
    }

    function onDragChange(e) {
        let visibleRows = e.component.getVisibleRows();

        let sourceNode = e.component.getNodeByKey(e.itemData.id);
        let targetNode = visibleRows[e.toIndex].node;

        while (targetNode && targetNode.data) {
            if (targetNode.data.id === sourceNode.data.id) {
                e.cancel = true;
                break;
            }
            targetNode = targetNode.parent;
        }
    }

    function onReorder(e) {
        let visibleRows = e.component.getVisibleRows();
        let sourceData = e.itemData;
        let targetData = visibleRows[e.toIndex].data;
        let data = {
            domainId: sourceData.id,
            parentId: targetData.id
        };
        if (!e.dropInsideItem) {//araya taşındıysa
            data.parentId = null;
        }


        dispatch(AppActions.setLoading(true, "Taşıma işlemi yapılıyor.."));
        const request = new Request("/domain/moveDomain", "POST", data);
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.success) {
                    yenile();
                }
            });
    }

    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: (e) => { return  formYetki.ekle },
            options: {
                icon: 'add',
                onClick: () => {
                    addDetay(null);
                }
            }
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: (e) => { return  formYetki.excelSablon },
            options: {
                icon: 'download',
                onClick: () => {
                    downloadSablon(null);
                }
            }
        });
    }

    function hideDomainDataPopup() {
        setDomainData({ popupState: false, data: {} })
        yenile();
    }

    function addDetay(data) {
        setDomainData({ popupState: true, data: { parent: data } })
    }

    function editDetay(data) {
        setDomainData({ popupState: true, data: data })
    }
    function deleteDetay(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili kaydı silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                let url = "/domain/deleteKayit/" + data.id;
                const request = new Request(url, "DELETE");
                dispatch(AppActions.setLoading(true, "Silme işlemi yapılıyor.."));
                return request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.data && response.data.success) {
                            yenile();
                        }
                    });
            }

        });

    }
    function domainTesvikDetaySil(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili Firmaya ait kayıtlı teşvikleri silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                let url = "/domain/domainTesvikDetaySil/" + data.id;
                const request = new Request(url, "DELETE");
                dispatch(AppActions.setLoading(true, "Silme işlemi yapılıyor.."));
                return request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.data && response.data.success) {
                            yenile();
                        }
                    });
            }

        });

    }
    function exceldenAktar(data) {
        if (inputOpenFileRef) {
            inputOpenFileRef.current.instance._isCustomClickEvent = true
            inputOpenFileRef.current.instance._$fileInput[0].click();
            inputOpenFileRef.current.instance._eventsStrategy._events.valueChanged = null;
            inputOpenFileRef.current.instance.on("valueChanged",
                (e1) => { 
                    let fileExtensionXlsx = e1.value[0].name.substring(e1.value[0].name.length - 5);
                    if (fileExtensionXlsx.toUpperCase() === ".XLSX") {
                        dosyaYukle(data,e1.value[0]);
                    } else {
                        showToast('Hatalı dosya tipi', ToastType.ERROR, 500);
                    }
                })
        }
    }

    function dosyaYukle(data,file) {

        const formData = new FormData();
        formData.append('file', file);

        const request = new Request("/domain/dosyaYukle/"+ data.id, "POST", formData, "multipart/form-data");
        dispatch(AppActions.setLoading(true, "Dosya Yükleniyor.."));
        request.run().then((response) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data === true) {
                showToast('Dosya başarılı bir şekilde yüklendi', ToastType.INFO, 500);
                yenile();
            }
        });

    }

    function downloadSablon(){
        const request = new Request("/domain/getExcelSablon", "GET");
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response,e,f) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) { 
                if(response.data.success){
              
                    let base64File =response.data.data;
                    const href =  'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +base64File;  
                    var a = window.document.createElement('a');
                    a.download =  'Firma Format.xlsx';
                    a.href = href;
                    a.click();
                    a.href = ''; 
                }else{ 
                         showToast(response.data.data.mesaj, ToastType.WARNING, 500); ;
                }
                
            }
        });
    }

    function yetkiliKullanicilistGoster(data) {
        const request = new Request("/domain/getYetkiliKullaniciList/" + data.id, "GET");
        dispatch(AppActions.setLoading(true, "Kullanıcı listesi yükleniyor..."));
        request.run().then((response, e, f) => {
            dispatch(AppActions.setLoading(false, "")); 
            if (response && response.data && response.data.data) { 
                let yetkiliKullanicilist = response.data.data.join("<br>");
                showDialog({ title: 'Yetkili Kullanıcı Listesi', message: yetkiliKullanicilist, buttons: "OK" });
            }
        });
    }

    function openPersonelCustomTesvikForm(data) {
        setPersonelCustomTesvikFormData({ popupState: true, data: data })
    }
    function hidePersonelCustomTesvikFormPopup() {
        setPersonelCustomTesvikFormData({ popupState: false, data: {} }) 
    }

    return (
        <div>
            <h2 className={"dx-icon-product"}> Firma Tanımları</h2>
            <div className="dx-field">
                <div className="buttons" align={"left"} style={{ marginLeft: "10px" }} ></div>
                <FileUploader
                    ref={inputOpenFileRef}
                    selectButtonText=""
                    labelText=""
                    visible={false}
                    accept={'.xml,.xlsx,.xls'}
                    allowedFileExtensions={'.xlsx'}
                    uploadMode="useForm" />
            </div>
            <TreeList
                id="menus"
                className="domainTree"
                rootValue={null}
                dataSource={store}
                showBorders={true}
                columnHidingEnabled={true}
                columnAutoWidth={true}
                showRowLines={true}
                defaultExpandedRowKeys={[1]}
                keyExpr={"id"}
                parentIdExpr={"parent.id"}

                onToolbarPreparing={onToolbarPreparingDetay}
            >
                <Selection mode="single" />
                <FilterRow visible={true} />
                <RowDragging
                    onDragChange={onDragChange}
                    onReorder={onReorder}
                    allowDropInsideItem={formYetki.moveDomain}
                    allowReordering={formYetki.moveDomain}
                    showDragIcons={formYetki.moveDomain}
                />
                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        {
                            hint: 'Excelden Aktar', icon: 'upload',
                            visible: (e) => { return formYetki.dosyaYukle && (e.row.data.sicilNo === undefined || e.row.data.sicilNo === null || e.row.data.sicilNo === "") },
                            onClick: (e) => { exceldenAktar(e.row.data); }
                        },
                        {
                            hint: 'Kullanıcı Listesi', icon: 'user',
                            visible: () => { return formYetki.yetkiliKullanicilist },
                            onClick: (e) => {
                                yetkiliKullanicilistGoster(e.row.data);
                            }
                        },
                        {
                            hint: 'Ekle', icon: 'add',
                            visible: (e) => { return formYetki.ekle },
                            onClick: (e) => { addDetay(e.row.data); }
                        },
                        {
                            hint: 'Düzenle', icon: 'edit',
                            visible: (e) => { return formYetki.degistir },
                            onClick: (e) => { editDetay(e.row.data); }
                        },
                        {
                            hint: 'Sil', icon: 'remove',
                            visible: (e) => { return formYetki.sil },
                            onClick: (e) => { deleteDetay(e.row.data); }
                        },
                        {
                            hint: 'Personel Teşvik Sorgu Tanımı', icon: 'find',
                            visible: (e) => { return formYetki.domainCutomTesvikForm && (e.row.data.sicilNo != null && e.row.data.sicilNo != "") },
                            onClick: (e) => { openPersonelCustomTesvikForm(e.row.data); }
                        },
                        {
                            hint: 'Firmaya ait kayıtlı teşvikleri Sil', icon: 'remove',
                            visible: (e) => { return formYetki.domainTesvikDetaySil && (e.row.data.sicilNo != null && e.row.data.sicilNo != "") },
                            onClick: (e) => { domainTesvikDetaySil(e.row.data); }
                        },
                    ]}
                />
                <Column dataField="name" caption="Adı" defaultSortOrder="asc" />
                <Column dataField="sicilNo" caption="Sicil" />
                <Column dataField="araciNo" caption="Aracı No" />
                <Column dataField="ilPlaka" caption="İlKodu" />
                
            </TreeList>

            <Popup
                visible={domainData.popupState}
                onHiding={hideDomainDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Firma Detay Bilgi"
                width={750}
                height={400}
            >
                <div>
                    {domainData.popupState ? <DomainDetay data={domainData.data} hide={hideDomainDataPopup} /> : null}
                    <div>  </div>
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideDomainDataPopup}
                    />
                </div>
            </Popup>
            
            <Popup
                visible={personelCustomTesvikFormData.popupState}
                onHiding={hidePersonelCustomTesvikFormPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Firma Detay Bilgi"
                width={450}
                height={600}
            >
                <div>
                    {personelCustomTesvikFormData.popupState ? <DomainCustomTesvikPersonel data={personelCustomTesvikFormData.data} hide={hidePersonelCustomTesvikFormPopup} /> : null}
                    <div>  </div>
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hidePersonelCustomTesvikFormPopup}
                    />
                </div>
            </Popup>


        </div>
    );
};

export default Domain;
